module.exports = __webpack_public_path__ + "media/dashboard/assets/images/opportunity-pipelines/empty-stages-cd1255b679d3a71ecc75d3cb1b28f430.svg";